import { JobNotificationCardModel } from '../job-notification-card.model';

export class PdfMergeNotificationCardModel extends JobNotificationCardModel {
  public facturXBadgeFlag: boolean;
  public ublBadgeFlag: boolean;
}
